import { VectorProps } from "../types/vectors";

const LogoGranicus = ({
  size="300",
  primary="#CE3B4E",
  secondary="#212121",
}: VectorProps) => (
  <svg version="1.1" width={size} viewBox="0 0 189.5 39" x="0px" y="0px" xmlns="http://www.w3.org/2000/svg">
  <g>
    <path fill={primary} className="st0" d="M33.4,13.4h1.3l-0.1-0.1c-2.5-6.1-8.4-10.1-15-10.1c-9,0-16.3,7.3-16.3,16.3c0,9,7.3,16.3,16.3,16.3
      c4.2,0,8.3-1.6,11.3-4.6c3-3,4.8-6.9,4.9-11.1l0-0.1H17v1.2h17.6c-0.4,3.7-2.1,7-4.8,9.5c-2.8,2.5-6.4,3.9-10.1,3.9
      c-8.3,0-15.1-6.8-15.1-15.1c0-8.3,6.8-15.1,15.1-15.1C25.6,4.4,31,7.9,33.4,13.4L33.4,13.4z"/>
    <path fill={primary} d="M39.1,17.2L39.1,17.2l-19.3-0.1v1.2H38c0,0.4,0,0.8,0,1.2c0,10.2-8.3,18.4-18.4,18.4S1.2,29.7,1.2,19.5
      C1.2,9.3,9.5,1.1,19.6,1.1C27.4,1.1,34.4,6,37,13.4l0,0.1h1.3l0-0.1c-2.7-8-10.2-13.4-18.6-13.4C8.8-0.1,0,8.7,0,19.5
      s8.8,19.6,19.6,19.6s19.6-8.8,19.6-19.6C39.2,18.7,39.2,18,39.1,17.2z"/>
    <path fill={primary} d="M19.6,7.8c4.1,0,7.8,2.1,9.9,5.5l0,0h1.4l-0.1-0.2c-2.3-4.1-6.6-6.6-11.2-6.6c-7.1,0-12.8,5.8-12.8,12.8
      s5.8,12.8,12.8,12.8c5.8,0,10.8-3.9,12.4-9.4l0-0.1H19.8V24h10.6c-1.8,4.4-6,7.2-10.7,7.2C13.2,31.2,8,25.9,8,19.5
      C8,13.1,13.2,7.8,19.6,7.8z"/>
  </g>
  <g>
    <path fill={secondary} d="M83.3,20c0.9-0.9,1.3-2.1,1.3-3.3c0-3-2.5-4.7-4.3-4.7h-9.5v1.5h3.3v13.8h1.5v-6h3.4c0.8,1.2,1.7,2.5,2.5,3.7
      l0.1,0.1c0.5,0.7,1,1.4,1.5,2.1l0.1,0.2H85l-4.3-6C81.6,21.3,82.6,20.8,83.3,20z M80.5,19.9h-4.9v-6.4h4.7c1.2,0,2.9,1.1,2.9,3.2
      C83.2,18.5,81.7,19.9,80.5,19.9z"/>
    <path fill={secondary} d="M97.3,12.1h-1l-5.9,15.3h1.5l1.5-3.8h6.9l1.5,3.8h1.5L97.3,12.1L97.3,12.1z M99.7,22.2h-5.7l2.9-7.5L99.7,22.2
      z"/>
    <path fill={secondary} d="M120.2,24.7l-2.8-3.6c-2.2-2.8-4.7-5.9-7-8.9l-0.1-0.2H109v15.3h1.5V14.7l10.1,12.7l0,0h0.2c0.1,0,0.2,0,0.3,0
      c0.1,0,0.1,0,0.2,0h0.4V12.1h-1.5V24.7z"/>
    <rect x="130.3" y="12.1" fill={secondary} width="1.4" height="15.3"/>
    <path fill={secondary} d="M169.9,20c0,4-1.5,6.1-4.5,6.1c-3.1,0-4.7-2-4.7-5.9v-8.1h-4.5v1.4h3.1l0,3.6c0,1.4,0,2.7,0,3.1
      c0,4.7,2.2,7.3,6.1,7.3c3.9,0,6-2.6,6-7.5v-7.9h-1.4V20z"/>
    <path fill={secondary} d="M184.3,18.9c-2.2-0.4-4.7-1-4.7-2.8c0-1.9,2.2-2.8,4.2-2.8c1.7,0,2.9,0.5,3.8,1.5l0.3,0.3l1.1-1l-0.3-0.3
      c-1.2-1.3-2.8-1.9-4.9-1.9c-2.7,0-5.7,1.3-5.7,4.2c0,2.8,3,3.7,5.7,4.2l0.1,0c0.1,0,0.3,0.1,0.5,0.1c1.5,0.3,3.6,0.6,3.6,2.6
      c0,2.4-3,3.1-4.5,3.1c-1.6,0-3.3-0.7-4.2-1.3l-0.4-0.3l-0.8,1.2l0.4,0.2c1.1,0.8,3.1,1.5,5,1.5c0.6,0,2.3-0.1,3.8-0.9
      c1.4-0.8,2.2-2,2.2-3.6C189.5,19.7,185.8,19.2,184.3,18.9z"/>
    <path fill={secondary} d="M59,21.1h5.6c-0.6,3-3.2,5.2-6.4,5.2c-3.6,0-6.5-2.9-6.5-6.4c0-3.5,2.9-6.4,6.5-6.4c2.5,0,4.9,1.6,6,3.9
      l0.1,0.3H66l-0.2-0.6c-1.2-3-4.2-5-7.5-5c-4.4,0-8,3.5-8,7.8c0,4.3,3.6,7.8,8,7.8c4.3,0,7.8-3.3,8-7.5l0-0.5H59V21.1z"/>
    <path fill={secondary} d="M146.4,26.2c-3.6,0-6.5-2.9-6.5-6.4c0-3.5,2.9-6.4,6.5-6.4c1.7,0,3.4,0.8,4.6,2c0.4-0.3,0.8-0.7,1.2-1
      c-1.5-1.5-3.6-2.5-5.8-2.5c-4.4,0-8,3.5-8,7.8c0,4.3,3.6,7.8,8,7.8c2.4,0,4.6-1.1,6.1-2.8l-1.2-0.9
      C150.2,25.3,148.4,26.2,146.4,26.2z"/>
  </g>
  </svg>
);

export default LogoGranicus;
